import { NotificationProvider } from "@refinedev/core"
import { toast } from "@/components/ui/use-toast"

export const notificationProvider: NotificationProvider = {
  open: ({ message, description, type }) => {
    const variant = type === "error" ? "destructive" : type === "success" ? "success" : "default"
    toast({
      title: message,
      description: description,
      variant,
    })
  },
  close: () => {
    // Toasts auto-dismiss
  },
}
